/* eslint-disable require-jsdoc */
export function selectIsOpen(state) {
    return state.newsletterStrip.isOpen;
}
